import { render, staticRenderFns } from "./PartesInteresadas.vue?vue&type=template&id=41a11969&"
import script from "./PartesInteresadas.vue?vue&type=script&lang=js&"
export * from "./PartesInteresadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports